import { render, staticRenderFns } from "./contact-group-for-list.vue?vue&type=template&id=c21c4de6&"
import script from "./contact-group-for-list.vue?vue&type=script&lang=ts&"
export * from "./contact-group-for-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports